export default __webpack_public_path__ + "static/media/Luigi Nacci premiato.6a723d63.jpg";